import React, { useEffect } from 'react';

import { useNavigate } from 'react-router-dom';
import { kcGateway } from '../../utils/keycloak';

export const NEXT_URL_STORAGE_KEY = 'nextUrl';

const AuthCallbackPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const signInCallbackFunc = async () => {
      try {
        await kcGateway.signInCallback();
      } catch (error) {
        console.error(error);
      } finally {
        const redirectUrl = sessionStorage.getItem(NEXT_URL_STORAGE_KEY) || '/';

        navigate(redirectUrl);
      }
    };

    signInCallbackFunc();
  }, [navigate]);

  return <div />;
};

export default AuthCallbackPage;
